export const red = {
  active: 'hsla(17, 100%, 56%, 1)',
  A800: 'hsla(357, 95%, 64%, 1)',
  800: 'hsla(0, 66%, 47%, 1)',
  700: 'hsla(0, 65%, 51%, 1)',
  600: 'hsla(1, 77%, 55%, 1)',
  500: 'hsla(4, 90%, 58%, 1)',
  400: 'hsl(1, 83%, 63%, 1)',
  100: 'hsla(354, 96%, 90%, 1)',
  50: 'hsla(351, 90%, 96%, 1)',
};

export type RedPalette = typeof red;
